import { Typography, TypographyProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FeedbackType } from "../types/commonCDSTypes";
import { getCdsTextColor } from "./CdsFeedbackTextField";

type Props = Omit<TypographyProps, "children"> & {
  disabled?: boolean;
  feedbackType?: FeedbackType;
  children: React.ReactNode;
};

export default function VitalCdsUnitTypography({
  disabled,
  feedbackType,
  children,
  sx,
  pl = 1,
  variant = "body2",
  ...rest
}: Props) {
  const theme = useTheme();
  const unitCdsColor =
    disabled && feedbackType
      ? getCdsTextColor(feedbackType, theme.palette)
      : null;

  return (
    <Typography
      pl={pl}
      variant={variant}
      sx={[
        unitCdsColor
          ? {
              color: `${unitCdsColor} !important`,
              WebkitTextFillColor: `${unitCdsColor} !important`,
              opacity: 1,
            }
          : { color: "text.secondary" },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...rest}
    >
      {children}
    </Typography>
  );
}
